import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-files-drop-uploader',
  templateUrl: './files-drop-uploader.component.html',
  styleUrls: ['./files-drop-uploader.component.scss'],
})
export class FilesDropUploaderComponent implements OnInit, OnChanges {
  @Input() title: string = 'Arrastra aquí tus archivos';
  @Input() subtitle: string = 'Arrastra y suelta tus archivos aquí';
  @Input() accept: string = '*/*';
  @Input() multiple: boolean = false;
  @Output() filesDropped = new EventEmitter<File[]>();
  @Input() initialFiles: File[] = [];

  files: File[] = [];

  constructor() {
  }

  ngOnInit(): void {
    if (this.initialFiles && this.initialFiles.length > 0) {
      this.files = [...this.initialFiles];
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['initialFiles'] && changes['initialFiles'].currentValue) {
      this.files = [...changes['initialFiles'].currentValue];
    }
  }

  onSelect(event: any) {
    if (!this.multiple) {
      this.files = [event.addedFiles[0]];
    } else {
      this.files.push(...event.addedFiles);
    }
    this.filesDropped.emit(this.files);
  }

  onRemove(file: File) {
    this.files = this.files.filter((f) => f !== file);
    this.filesDropped.emit(this.files);
  }

  clearFiles() {
    this.files = [];
    this.filesDropped.emit(this.files);
  }
}
